export default __webpack_public_path__ + "static/media/google-share-1.aa49bf1b.jpeg";